/**
 * CSV の低レベル read/write (RFC 4180 互換のサブセット)。
 * - フィールド内の `,` `"` 改行は `"..."` でクォート、`"` は `""` でエスケープ
 * - 改行は \n / \r\n 両対応
 */

export function escapeCsvField(value: string): string {
  if (value === "") return "";
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function joinCsvRow(fields: string[]): string {
  return fields.map(escapeCsvField).join(",");
}

/** 1 行をフィールド配列に分解 (クォート / エスケープ対応) */
export function splitCsvLine(line: string): string[] {
  const fields: string[] = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cur += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ",") {
        fields.push(cur);
        cur = "";
      } else {
        cur += ch;
      }
    }
  }
  fields.push(cur);
  return fields;
}

/** \r\n を \n に正規化して行配列に分解 (空行は維持) */
export function splitLines(text: string): string[] {
  return text.replace(/\r\n?/g, "\n").split("\n");
}
